import { get, writable } from 'svelte/store';

export const chatEnabled = writable(false);
export const chattingWithUser = writable(false);
export const chatSupportHasMessageStore = writable(false);

export function openChat() {
	chatEnabled.set(true);
	chattingWithUser.set(true);
	chatSupportHasMessageStore.set(false);
}

export function disableChat() {
	chatEnabled.set(false);
}

export function toggleChat() {
	if (get(chatEnabled)) {
		disableChat();
	} else {
		openChat();
	}
}
